import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog, DialogContent, useMediaQuery,
    useTheme
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import { TransitionProps } from '@mui/material/transitions';
import Typography from '@mui/material/Typography';
import withHooks from '../../../../utils/withHooks';
import WhatsappNotifyComp from './WhatsappNotifyFormComp';
import { ApptContext } from '../../contexts/appointment.context';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class WhatsappNotifyModal extends React.Component<any, any, {}> {

    state: any;


    constructor(props: any) {
        super(props);

        this.state = {
            open: props.open ?? false,
        }
    }

    get apptContext() {
        return this.props.apptContext;
    }

    render(): React.ReactNode {

        
        const { setNotiModal, openNotiModal } = this.apptContext;
        console.log(this.props)
       

        return <>
            <Dialog
                fullScreen={this.props.isMd}
                open={openNotiModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{
                    width: `${!this.props.isMd ? '500px' : 'auto'}`,
                    position: 'relative',
                    background: 'none',
                    boxShadow: 'none !important',
                    color: 'neutral.900',
                }}>
                    <Toolbar>
                        <Typography sx={{ flex: 1 }} variant="h6" component="div">
                            WhatsApp Options
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="close"
                            onClick={() => setNotiModal(!openNotiModal)}

                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <WhatsappNotifyComp />
                </DialogContent>
            </Dialog>
        </>
    }
}

export default withHooks(WhatsappNotifyModal, [
    ['isMd', (() => useMediaQuery((theme: any) => theme.breakpoints.down('md')))],
    ['apptContext', React.useContext, [ApptContext]],
    ['theme', useTheme]
]);